import { useEffect, useState, useRef, useContext } from 'react';
import '../../../styles/game/GameBoard.css';
import { useData } from '../../../providers/SocketContext.jsx'

function DataMultiplier() {
    const {resultData} = useData()


    const [dataSize, setDataSize] = useState(0);
    
    useEffect(() => {

        const resizeFont = () => {
            const width = window.innerWidth;
            if(width > 992) {
                setDataSize(108);

            } else if (width < 992 && width > 500) {
                setDataSize(78)

            } else if (width < 500) {
                setDataSize(70)

            }
        }
        resizeFont()
        window.addEventListener('resize', resizeFont);

        return () => {
            window.removeEventListener('resize', resizeFont);
            
            
          };
    }, [])

    const multiplierText = {
        fontSize: `${dataSize}px`,
        letterSpacing: "3px",
    }

    return (
        <>
            <div className={"data-multiplier-wrapper"}>
                <div style={multiplierText}>{resultData ? `${resultData}x` : ""}</div>
            </div>
        </>
    )
}

export default DataMultiplier; 